/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Input_SearchInputs */

const es_user_input_search = /** @type {(inputs: User_Input_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar usuario…`)
};

const en_user_input_search = /** @type {(inputs: User_Input_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search user…`)
};

/**
* | output |
* | --- |
* | "Search user…" |
*
* @param {User_Input_SearchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_input_search = /** @type {((inputs?: User_Input_SearchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Input_SearchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_input_search(inputs)
	return en_user_input_search(inputs)
});
export { user_input_search as "user_input.search" }